export default __webpack_public_path__ + "static/media/product-10.b8677e9c.webp";